<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>积分兑换管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in statusOptions"
          :key="item.id"
          :label="item.value"
        ></el-tab-pane>
      </el-tabs>

      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            placeholder="请输入家长姓名"
            v-model="queryInfo.name"
            clearable
            @clear="getList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="请输入学生姓名"
            v-model="queryInfo.s_name"
            clearable
            @clear="getList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table :data="userlist" border stripe style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column
          label="订单号"
          prop="id"
          width="60px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="家长姓名"
          prop="name"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="学生姓名"
          prop="s_name"
          width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="电话"
          prop="phone"
          width="90px"
          align="center"
        ></el-table-column>

        <el-table-column
          label="礼品名称"
          prop="s_title"
          align="center"
          width="180px"
        ></el-table-column>
        <el-table-column
          label="积分数"
          prop="jifenCount"
          align="center"
          width="60px"
        ></el-table-column>

        <el-table-column
          label="兑换时间"
          align="center"
          prop="create_at"
          width="140px"
        ></el-table-column>
        <el-table-column
          label="领取时间"
          align="center"
          prop="get_at"
          width="140px"
        ></el-table-column>

        <el-table-column label="状态" align="center" width="80px">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'"
              >未领取</el-tag
            >
            <el-tag class="success" v-if="scope.row.status == '1'"
              >已领取</el-tag
            >
            <el-tag class="danger" v-if="scope.row.status == '2'"
              >已拒绝</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="拒绝理由" prop="seasion"></el-table-column>

        <el-table-column label="操作" width="200px" v-if="canLook == 1">
          <template slot-scope="scope" v-if="scope.row.status == '0'">
            <!-- 通过按钮 -->
            <el-tooltip
              effect="dark"
              content="已领取"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="primary"
                icon="el-icon-success"
                size="mini"
                @click="agreen(scope.row.id)"
                >已领取</el-button
              >
            </el-tooltip>
            <!-- 拒绝按钮 -->
            <el-tooltip
              effect="dark"
              content="拒绝"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="refuse(scope.row.id)"
                >拒绝</el-button
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 对话框 -->
    <el-dialog
      title="打回"
      :visible.sync="sendBackDialogVisible"
      width="50%"
      @close="sendBackDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="sendBackForm"
        :rules="sendBackRules"
        ref="sendBackRef"
        label-width="130px"
      >
        <el-form-item label="拒绝理由" prop="seasion">
          <el-input
            maxlength="15"
            v-model="sendBackForm.seasion"
            placeholder="输入拒绝理由，最长15字"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendBackDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postRefuse">拒绝</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabIndex: 0,
      canLook: 1,

      // 获取列表的参数对象
      queryInfo: {
        name: "",
        s_name: "",
        id: "",
        status: -1,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      list: [], //预览图片数组
      userlist: [],
      total: 0,
      sendBackid: 0,
      sendBackDialogVisible: false,
      sendBackForm: {
        seasion: "",
      },
      sendBackRules: {
        seasion: [
          { required: true, message: "请输入打回理由", trigger: "blur" },
        ],
      },
      statusValue: "全部",
      statusOptions: [
        { value: "全部", id: -1 },
        { value: "待领取", id: 0 },
        { value: "已领取", id: 1 },
        { value: "已拒绝", id: 2 },
      ],
    };
  },

  created() {
    this.getList();
  },

  methods: {
    handleClick(tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      this.queryInfo.status = this.tabIndex - 1;
      this.filterSelect();
    },

    timechange(e) {
      this.filterSelect();
    },

    //搜索
    search() {
      this.filterSelect();
    },

    filterSelect() {
      this.total = 0;
      this.queryInfo.pagenum = 1;
      this.userlist = [];
      this.getList();
    },

    async getList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get(
        "admin/users/getJifenDuihuanList",
        {
          params: this.queryInfo,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("暂无兑换信息！");
      }
      this.userlist = res.result.list;
      this.total = res.result.count;
      this.list = [];
      console.log(this.userlist);
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },

    // 监听添加用户对话框的关闭事件
    sendBackDialogClosed() {
      this.$refs.sendBackRef.resetFields();
      this.sendBackid = 0;
      this.sendBackDialogVisible = false;
    },

    // 通过
    async agreen(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        "请确认礼品已发放后修改为已领取, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消");
      }
      // 在展示对话框之前，获取所有角色的列表
      const { data: res } = await this.$http.post(
        "admin/users/completeJifenDuihuan",
        {
          id: id,
        }
      );
      if (res.code !== 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("操作成功！");
      this.getList();
    },

    refuse(id) {
      this.sendBackid = id;
      this.sendBackDialogVisible = true;
    },

    // 拒绝
    async postRefuse() {
      this.$refs.sendBackRef.validate(async (valid) => {
        if (!valid) return;
        // 在展示对话框之前，获取所有角色的列表
        const { data: res } = await this.$http.post(
          "admin/users/refuseJifenDuihuan",
          {
            id: this.sendBackid,
            seasion: this.sendBackForm.seasion,
          }
        );
        if (res.code !== 200) {
          return this.$message.error("操作失败！");
        }
        this.$message.success("操作成功！");
        this.sendBackid = 0;
        this.sendBackDialogVisible = false;
        this.getList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.danger {
  background-color: rgb(237, 94, 94);
  color: white;
}
</style>
